import { useEffect } from 'react';

import { useFormikContext } from 'formik';

export const ScrollToError = () => {
  const formik = useFormikContext();
  const submitting = formik?.isSubmitting;

  useEffect(() => {
    const el = document.querySelector('.Mui-error, [data-error]');
    (el?.parentElement ?? el)?.scrollIntoView({
      behavior: 'smooth',
    });
  }, [submitting]);

  return null;
};
